import React, { useEffect, useMemo, useState } from "react";
import { RouteComponentProps, withRouter } from "react-router";
import clsx from "clsx";

import { useAppDispatch, useAppSelector } from "@app/redux/store";
import { MyDealAlertsModule } from "@app/api/modules/my-deal-alerts/my-deal-alerts.module";
import { authThunks } from "@app/redux/thunks/auth.thunk";
import { DealCardAlert } from "@app/components/deal-alert-cards/deal-card-alert/deal-card-alert";
import { formatMessage } from "@app/translations/intl";

import { DealAlertSearch } from "./components/deal-alert-search";
import styles from "./my-deal-alerts.module.scss";

const TOKEN_SEARCH_PARAM = "token";

export interface IMyDealAlertsModuleProps {
  module: MyDealAlertsModule;
}

const component = ({ module, ...props }: IMyDealAlertsModuleProps & RouteComponentProps) => {
  const { sidebarDescription, sidebarDescriptionNoUser, sidebarTitle, searchPlaceholder } = module;
  const { user } = useAppSelector(state => state.auth);
  const [isDropdownOpen, setIsDropdownOpen] = useState<boolean>(false);
  const dispatch = useAppDispatch();
  const authToken = new URLSearchParams(props.location.search).get(TOKEN_SEARCH_PARAM) || "";

  const title = useMemo(() => getTitle(module.title, user?.dataWarehouseProduct?.length), [module.title, user]);

  useEffect(() => {
    if (user || !authToken) {
      props.history.replace({ search: "" });
      return;
    }

    dispatch(authThunks.login(authToken));
    props.history.replace({ search: "" });
  }, [authToken]);

  const handleLogout = () => {
    dispatch(authThunks.logout());
  };

  return (
    <div className="uk-container">
      <div className={styles.root}>
        <div className={styles.content}>
          {title && <h2>{title}</h2>}
          {/* <DealAlertSearch searchPlaceholder={searchPlaceholder} onDropdownToggle={setIsDropdownOpen} /> */}

          {user && (user?.dataWarehouseProduct || []).length > 0 && (
            <div className={clsx(styles.list, isDropdownOpen && styles.isDropdownOpen)}>
              {user.dataWarehouseProduct.map(deal => (
                <DealCardAlert key={deal.id} deal={deal} className={styles.card} />
              ))}
            </div>
          )}
        </div>
        <div className={styles.sidebarWrapper}>
          <div
            className={clsx(
              styles.sidebar,
              isDropdownOpen && (user?.dataWarehouseProduct || []).length === 0 && styles.isDropdownOpen
            )}
          >
            {sidebarTitle && <h3>{sidebarTitle}</h3>}
            {user?.email && (
              <span className={styles.info}>
                <span>{user.email} </span>
                <button type="button" className={styles.logoutButton} onClick={handleLogout}>
                  ({formatMessage({ id: "myDealAlerts.logout.title" })})
                </button>
              </span>
            )}
            <p>{user ? sidebarDescription : sidebarDescriptionNoUser}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

const MyDealAlerts = withRouter(component);
export { MyDealAlerts };

const getTitle = (title?: string, dealAmount?: number) => {
  const replacement = dealAmount?.toString() || "";

  return (title || "").replaceAll("{amount}", replacement).replaceAll("()", replacement);
};
